/**
 * OVERRIDE NotFound.jsx
 */

import NotFound from '../../../../components/NotFound/NotFound';

export default NotFound;